import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./Welcome.css";

function Welcome() {
  const navigate = useNavigate();
  const location = useLocation();

  const username = location.state?.fullname || "User";
  const idvender = location.state?.idvender || "";
  const userinuse = location.state?.userinuse || "";
  const wherefrm = location.state?.wherefrm || "";

  console.log("fullname:", username);
  console.log("idvender:", idvender);
  console.log("userinuseFRMwelcome", userinuse);
  console.log("wherefrm_", wherefrm);

  const handleLogout = () => {
    navigate("/"); // กลับไปหน้า Login
  };

  return (
    <div className="welcome-container">
      <nav className="navbar">
        <div className="navbar-logo">
          <img src="assets/logo.png" alt="Logo" />
          <span className="navbar-title">Welcome, {username}</span>
        </div>
        <ul className="navbar-menu">
          <li
            onClick={() =>
              navigate("/upload", {
                state: { fullname: username, idvender: idvender },
              })
            }
          >
            Unit price / Invoice confirmation
          </li>

          <li
            onClick={() =>
              navigate("/po", {
                state: {
                  fullname: username,
                  idvender: idvender,
                  userinuse: userinuse,
                  wherefrm: wherefrm,
                },
              })
            }
            // style={{
            //   pointerEvents: "none",
            //   opacity: 0.5,
            //   cursor: "not-allowed",
            // }}
          >
            Purchase Order Confirmation
          </li>
          <li
            onClick={() =>
              navigate("/forecast", {
                state: {
                  fullname: username,
                  idvender: idvender,
                  userinuse: userinuse,
                  wherefrm: wherefrm,
                },
              })
            }
          >
            Forecast Confirmation
          </li>
          <li className="logout" onClick={handleLogout}>
            Logout
          </li>
        </ul>
      </nav>

      <div className="welcome-content">
        <h1>🎉 Welcome, {username}!</h1>
        <p>Select an option from the menu above to get started.</p>
      </div>

      <div className="welcomes-container">
        <nav>...</nav>
        <div className="welcomes-content">...</div>

        <footer className="app-footer">
          <span>Version 1.0.6</span>
          <span>© 2026 Your Company. All rights reserved.</span>
        </footer>
      </div>
    </div>
  );
}

export default Welcome;
